<div class="legacy-dialog-header" mat-dialog-title>
	<div class="legacy-dialog-header-title" translate>login-legacy.wrong-connexion</div>
	<div class="legacy-dialog-header-subtitle">
		<button type="button" (click)="closeDialog()">x</button>
	</div>
</div>
<div class="legacy-dialog-body" mat-dialog-content *ngIf="errorStatus">
	<div [ngSwitch]="errorStatus">
		<div translate>
			<ng-container *ngSwitchCase="'user_not_found'">login.user-not-found</ng-container>
			<ng-container *ngSwitchCase="'bad_password'">
				<p translate>login.bad-password</p>
				<p translate>login.password-attempts-exceeded</p>
			</ng-container>
			<ng-container *ngSwitchCase="'password_attempt_blocked'">login.password-attempts-blocked</ng-container>
			<ng-container *ngSwitchCase="'password_already_used'">confirm-password-legacy.password-already-used</ng-container>
			<ng-container *ngSwitchCase="'password-not-respect-rules'">confirm-password-legacy.password-not-respect-rules</ng-container>
			<ng-container *ngSwitchCase="'client_id_not_found'">login.client-id-not-found</ng-container>
			<ng-container *ngSwitchCase="'unknown_redirect_uri'">login.unknown-redirect-uri</ng-container>
			<ng-container *ngSwitchCase="'client_id_outdated'">login.client-id-outdated</ng-container>
			<ng-container *ngSwitchCase="'client_id_disabled'">login.client-id-disabled</ng-container>
			<ng-container *ngSwitchCase="'invalid_user_type'">login.user-doesnt-have-access</ng-container>
			<ng-container *ngSwitchDefault>login.unknown-error</ng-container>
		</div>
	</div>
</div>
